import { initFirebase } from '../firebase'
import { collection, getDocs, query, orderBy, doc, getDoc, deleteDoc } from 'firebase/firestore'

const { db } = initFirebase()

export class FirebaseIntentLogService {
  constructor() {}

  async getAllIntentLogs() {
    try {
      const logsRef = collection(db, 'ai-intent')
      const q = query(logsRef, orderBy('timestamp', 'desc'))
      const querySnapshot = await getDocs(q)
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
    } catch (error) {
      console.error('Error fetching intent logs:', error)
      throw error
    }
  }

  async getIntentLogById(logId) {
    try {
      const logRef = doc(db, 'ai-intent', logId)
      const logDoc = await getDoc(logRef)
      if (logDoc.exists()) {
        return {
          id: logDoc.id,
          ...logDoc.data()
        }
      }
      return null
    } catch (error) {
      console.error('Error fetching intent log:', error)
      throw error
    }
  }

  async deleteIntentLog(logId) {
    try {
      const logRef = doc(db, 'ai-intent', logId)
      await deleteDoc(logRef)
    } catch (error) {
      console.error('Error deleting intent log:', error)
      throw error
    }
  }
}
